<div class="breadcrumb">
  <div class="container">
    <a routerLink="/">{{ 'Home' | translate }}</a> > <a routerLink="/receitas-pending-issues">{{ 'Receitas pendentes' | translate}}</a> > {{ 'Detalhe' | translate}}
  </div>
</div>

<main class="container">
  <div class="flex gap-2" [ngClass]="{'collapsed': isImageCollapsed}">
    <div class="collapse-icon">
      <button (click)="toggleCollapsedImage()" class="button_zomm">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 3H6a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h4M16 17l5-5-5-5M19.8 12H9"/></svg>
      </button>
    </div>

    <div class="item-3 overflow-hidden">
      <app-image-box
        [blobImage]="blobImage"
        [filenameText]="filenameText"
        [isImageCollapsed]="isImageCollapsed"
        [temAnterior]="temAnterior"
        [doShortcutActive]="doShortcutActive"
        [uid]="uid"
        (toggleCollapsedImage)="toggleCollapsedImage()"
        (voltar)="backSpace()"
        (anterior)="prescriptionBack()">
      </app-image-box>
    </div>

    <div class="item-3c">
      <form [formGroup]="form" *ngIf="form" class="scrollable formItem">
        <div class="aviso-conteudo-vazio" *ngIf="conteudoIndisponivel">
          {{ 'A IA não conseguiu extrair dados desta receita. Revise manualmente com base na imagem.' | translate }}
        </div>

        <div class="flex gap-1 info">
          <p i18n><strong>{{ 'Pais' | translate}}:</strong> {{paisName}}</p>
          <p i18n><strong>{{ 'Status' | translate}}:</strong> {{switchString(status) | translate}}</p>
          <p i18n><strong>{{ 'Região' | translate}}:</strong> {{getRegionName()}}</p>
          <p i18n><strong>{{ 'Farmácia' | translate}}:</strong> {{switchString(pdv)}}</p>
          <p i18n><strong>{{ 'Data de Leitura' | translate}}:</strong> {{data_de_leitura | date : 'dd/MM/yyyy HH:mm'}}</p>
          <p i18n><strong>{{ 'Data de revisão' | translate}}:</strong> {{data_de_revisao | date : 'dd/MM/yyyy HH:mm'}}</p>
          <p i18n><strong>{{ 'Grupo' | translate}}:</strong> {{groupName}}</p>

          <p class="data_prescription">
            <label><strong i18n>{{ 'Data da prescrição' | translate}}:</strong> </label>
            <input type="text" formControlName="dataReceita" [value]="prescriptionDate" (keypress)="validarEntrada($event)" appClearOnAltD />
          </p>

          <p class="butt">
            <button type="button" class="remove" (click)="nextPrescription()" i18n>{{ 'Próxima receita' | translate}}</button>
          </p>
        </div>

    <div class="w-100" style="position: relative;" *ngIf="isVisibleInstituicao">
      <app-institution-form-pending class="w-100"
        [instituicaoForm]="form.get('instituicao')"
        [isSmartCase]="isSmartCase"
        [isVisibleEnderecoinstituicao]="isVisibleEnderecoinstituicao"
        [codigoPaisMaestro]="codigoPaisMaestro"
        [mostrarPendencias]="mostrarPendencias"
        (validarEntrada)="validarEntrada($event)"
        (isValidatedChange)="isInstValidado = $event">
      </app-institution-form-pending>
    </div>

        <app-doctor-form-pending class="w-100"
          [medicoForm]="form.get('medico')"
          [prescriptionItem]="thisItem"
          [isSmartCase]="isSmartCase"
          [isVisibleEnderecoMedico]="isVisibleEnderecoMedico"
          (validarEntrada)="validarEntrada($event)"
          [codigoPaisMaestro]="codigoPaisMaestro"
          [codigoRegiaoMaestro]="codigoRegiaoMaestro"
          [mostrarPendencias]="mostrarPendencias"
          (isValidatedChange)="isDocValidado = $event"
          *ngIf="isVisibleNomeMedico">
        </app-doctor-form-pending>

        <app-product-form-pending class="w-100"
          [produtoForm]="produtos"
          [prescriptionItem]="thisItem"
          [isSmartCase]="isSmartCase"
          [doShortcutActive]="doShortcutActive"
          (validarEntrada)="validarEntrada($event)"
          [codigoPaisMaestro]="codigoPaisMaestro"
          [mostrarPendencias]="mostrarPendencias"
          (isValidatedChange)="isProdValidado = $event"
          *ngIf="isVisibleProduto">
        </app-product-form-pending>

         <div class="diagnosis w-100" *ngIf="isVisibleDiagnostico">
          <div class="flex_small">
            <div class="diagnosis_buttons flex gap-1">
              <div *ngFor="let diag of diagnosticos.controls | slice:0:6; let i = index" class="diagnosis_item">
                <label><strong i18n>{{ 'Diagnóstico' | translate}} {{i + 1}}</strong></label>

                <ng-container *ngIf="isSmartCase; else diagnosticoNormalInput">
                  <input type="text" [formControl]="diag" (keypress)="validarEntrada($event)" appClearOnAltD appSmartCase class="diag-input" />
                </ng-container>
                <ng-template #diagnosticoNormalInput>
                  <input type="text" [formControl]="diag" (keypress)="validarEntrada($event)" appClearOnAltD appLowercaseOnChange class="diag-input" />
                </ng-template>

                <button type="button" class="addRemoveButton" (click)="removerDiagnostico(i)" *ngIf="i>=2" i18n>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="8" y1="12" x2="16" y2="12"></line></svg>
                </button>
              </div>

              <div class="">
                <button type="button" class="addRemoveButton buttonSpecial" (click)="addDiagnostico()" i18n>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#aa0012" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="quality w-100">
          <div class="quality_buttons flex gap-1">
            <p><strong i18n>{{ 'Qualidade da imagem' | translate}}</strong></p>
            <label *ngFor="let quality of listImageQuality" class="flex gap-1" i18n>
              <input type="radio" formControlName="imageQuality" [value]="quality" appClearOnAltD [clearValue]="'Legivel'" /> {{ quality | translate }}
            </label>
          </div>

          <div class="infomation_buttons flex gap-1">
            <p i18n><strong>{{ 'Motivo de recusa' | translate}}</strong></p>

            <div class="filtro">
              <input
                  type="text"
                  formControlName="notReconize"
                  (keypress)="validarEntrada($event)"
                  (keydown.enter)="confirmRecusaEnter($event, recusaTrigger)"
                  class=""
                  [matAutocomplete]="autoRecusa"
                  #recusaTrigger="matAutocompleteTrigger"
                  matAutocompleteTrigger
                  appClearOnAltD
                  appLowercaseOnChange
                />

              <mat-autocomplete #autoRecusa="matAutocomplete">
                <!-- ✅ Exibe "code - name" e grava no input SOMENTE o name (string) -->
                <mat-option *ngFor="let recusaItem of infoNotRecognizedFiltred" [value]="recusaItem.name">
                  {{ recusaItem.code }} - {{ recusaItem.name | lowercaseCustom }}
                </mat-option>

                <mat-option *ngIf="infoNotRecognizedFiltred.length === 0" i18n disabled>
                  {{ 'Sem sugestões' | translate}}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>
          <div class="infomation_buttons flex gap-1">
            <div class="flex gap-1">
              <strong i18n>{{ 'Anonimizada' | translate}}:</strong>
              <input type="checkbox" formControlName="anonimizada" appClearOnAltD [clearValue]="false" />
            </div>
          </div>
        </div>
      </form>
      <div *ngIf="!form">
        <h1 i18n>{{ 'Formulário sendo editado por outro colaborador.' | translate}}</h1>
      </div>
      <div class="buttons_actions"></div>
      <div class="button_secondary center">
          <button type="submit" id="btnConfirma" *ngIf="status != 'W' && status != 'I'" class="ok" (click)="ok()" i18n>{{ 'Confirma Revisão' | translate}}</button>
          <button type="button" id="btnCancela" class="remove" (click)="cancelar()" i18n>{{ 'Cancela Revisão' | translate}}</button>
      </div>
   </div>
  </div>
</main>

<!-- Modal -->
<div class="modal" tabindex="-1" role="dialog" *ngIf="isModalOpen">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header flex space-between">
        <h5 class="modal-title" i18n>{{ 'Confirmação' | translate}}</h5>
        <button type="button" class="close" [attr.aria-label]="'Fechar' | translate" (click)="closeModal(true)">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p *ngIf="isCancelAction" i18n>{{ 'Tem certeza que deseja cancelar a revisão? Todas as alterações não salvas serão perdidas.' | translate}}</p>
        <p *ngIf="!isCancelAction && isRefused" i18n><strong>{{ 'Tem certeza que deseja salvar as alterações Recusando a Receita? A mesma não será enviada para captura eletrônica caso essa ação seja confirmada.' | translate}}</strong></p>
        <p *ngIf="!isCancelAction && !isRefused" i18n>{{ 'Tem certeza que deseja salvar as alterações?' | translate}}</p>
      </div>
      <div class="modal-footer">
        <ng-container *ngIf="isCancelAction">
          <button type="button" class="btn btn-primary" (click)="cancelarRevisao()" i18n>{{ 'Sim' | translate}}</button>
          <button type="button" class="btn btn-secondary" (click)="closeModal(true)" i18n>{{ 'Não' | translate}}</button>
        </ng-container>
        <ng-container *ngIf="!isCancelAction">
          <button type="button" class="btn btn-primary" #salvarButton (click)="saveChanges()" i18n>{{ 'Salvar' | translate}}</button>
          <button type="button" class="btn btn-secondary" (click)="closeModal(true)" i18n>{{ 'Cancelar' | translate}}</button>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal modal1" tabindex="-1" role="dialog" *ngIf="isModal1Open">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header flex space-between">
        <h5 class="modal-title" i18n>{{ 'Confirmação' | translate}}</h5>
        <button type="button" class="close" [attr.aria-label]="'Fechar' | translate" (click)="closeModal()">
          <!--span aria-hidden="true">&times;</span-->
        </button>
      </div>
      <div class="modal-body">
        <p i18n>{{ 'As alterações foram salvas com sucesso. Abrindo uma nova receita.' | translate}}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" #salvarButton1 (click)="nextPrescription()" i18n>{{ 'Continuar' | translate}}</button>
      </div>
    </div>
  </div>
</div>
